export default "__VITE_ASSET__D3ex3vUQ__"